<!--
分类标签组

使用说明：

<TagGroup
 :items="{TagGroup}"
 />

TagGroup=[
          {tagGroupId: 0,name: '标签组名', banner: 'Banner图片路径', tags: [
            {tagId: 9, img: '标签图片路径', name: '标签名'}
          ]}
        ];

-->

<template>
    <div class="category-item-wrap">
        <div class="taggroup-wrap" v-for="tg in items" :key="'tg-'+tg.tagGroupId" v-if="tg.tags.length > 0">
            <div class="taggroup-title">{{tg.name}}</div>
            <div class="taggroup-banner" :style="{backgroundImage:'url(' + tg.banner + ')'}" v-if="tg.banner" @click="gotoTagGroup(tg)"></div>
            <div class="tag-list">
                <div class="tag-wrap" v-for="t in tg.tags" :key="'t-'+t.tagId" @click="goto(t)">
                    <Icon class="tag-icon" :img="t.img | asTagImage" size="contain" />
                    <div class="tag-name">{{t.name}}</div>
                </div>
            </div>
            <div class="line"></div>
        </div>

    </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["items"],
  methods: {
    goto(tag) {
      this.$routerPush(this, "/pages/products/List?tagId="+tag.tagId);
    },
    gotoTagGroup(tg){
      this.$routerPush(this, "/pages/products/List?tagGroupId="+tg.tagGroupId);
    }
  },
  mounted(){
    
  }
};
</script>

<style lang="less" scoped>
@leftWidth: 28vw;

.category-item-wrap {
  position: relative;
  z-index: 1;

  &:last-child{
    min-height: 90vh;
  }
}

.taggroup-title {
  font-size: 3.46vw;
  color: #000;
  line-height: 12vw;
  padding: 0 5vw;
}

.taggroup-banner {
  width: 61.74vw;
  height: 23.2vw;
  background-position: center;
  background-size: cover;
  border-radius: 1vw;
  margin-left: 5vw;
}

.tag-list {
  margin-top: 4.4vw;
  text-align: left;
  font-size: 0;
}

.tag-wrap {
  display: inline-block;
  width: (100vw - @leftWidth) / 3;
  vertical-align: top;
  text-align: center;

  .tag-icon {
    background-position: center;
    background-size: cover;
    width: 12.2vw;
    height: 12.2vw;
    display: inline-block;
  }

  .tag-name {
    font-size: 3.2vw;
    line-height: 1.2em;
    color: #3b3b3b;
    margin: 3vw auto;
  }
}

.line {
  border-bottom: 1px solid #dedede;
  margin: 0 5vw;
}
</style>





// WEBPACK FOOTER //
// src/components/products/TagGroup.vue